let sdkPromise: Promise<boolean> | undefined;
export function loadIma(): Promise<boolean> {
  if ((window as Window & { google?: { ima?: unknown } }).google?.ima) return Promise.resolve(true);
  if (sdkPromise) return sdkPromise;
  sdkPromise = new Promise((resolve) => {
    const script = document.createElement("script");
    const finish = (success: boolean) => {
      clearTimeout(timer);
      script.onload = null;
      script.onerror = null;
      resolve(success);
    };
    const timer = window.setTimeout(() => finish(false), 6000);
    script.src = "https://imasdk.googleapis.com/js/sdkloader/ima3.js";
    script.async = true;
    script.onload = () => finish(Boolean((window as Window & { google?: { ima?: unknown } }).google?.ima));
    script.onerror = () => finish(false);
    document.head.appendChild(script);
  });
  return sdkPromise;
}
